export * from './apk.service';
import { ApkService } from './apk.service';
export * from './auditLog.service';
import { AuditLogService } from './auditLog.service';
export * from './branch.service';
import { BranchService } from './branch.service';
export * from './collection.service';
import { CollectionService } from './collection.service';
export * from './collectionMethod.service';
import { CollectionMethodService } from './collectionMethod.service';
export * from './dashboard.service';
import { DashboardService } from './dashboard.service';
export * from './forwardingAccounts.service';
import { ForwardingAccountsService } from './forwardingAccounts.service';
export * from './identity.service';
import { IdentityService } from './identity.service';
export * from './itinerary.service';
import { ItineraryService } from './itinerary.service';
export * from './loanDetails.service';
import { LoanDetailsService } from './loanDetails.service';
export * from './loanDetailsStatus.service';
import { LoanDetailsStatusService } from './loanDetailsStatus.service';
export * from './loanType.service';
import { LoanTypeService } from './loanType.service';
export * from './member.service';
import { MemberService } from './member.service';
export * from './remarks.service';
import { RemarksService } from './remarks.service';
export * from './standardEntries.service';
import { StandardEntriesService } from './standardEntries.service';
export * from './users.service';
import { UsersService } from './users.service';
export const APIS = [ApkService, AuditLogService, BranchService, CollectionService, CollectionMethodService, DashboardService, ForwardingAccountsService, IdentityService, ItineraryService, LoanDetailsService, LoanDetailsStatusService, LoanTypeService, MemberService, RemarksService, StandardEntriesService, UsersService];
